import { render, staticRenderFns } from "./SelfTestPelletizingList.vue?vue&type=template&id=84d50aaa&"
import script from "./SelfTestPelletizingList.vue?vue&type=script&lang=js&"
export * from "./SelfTestPelletizingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports